module.exports={small:"screen and (max-width: 699px)",big:"screen and (min-width: 700px)",large:"screen and (min-width: 1200px)"};